import { render, staticRenderFns } from "./WinView.vue?vue&type=template&id=67ec907c&scoped=true&"
import script from "./WinView.vue?vue&type=script&lang=js&"
export * from "./WinView.vue?vue&type=script&lang=js&"
import style0 from "./WinView.vue?vue&type=style&index=0&id=67ec907c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec907c",
  null
  
)

export default component.exports